// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import type { ValidationRules } from "@lg/shared";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { ProxyTargetSymbol } from "@lg/shared/for-apps";
import { Semaphore } from "@lg/shared/for-apps";
import { memoize } from "@lg/shared/for-apps";
import { NgSharedModule } from "@lg/ng-shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";
import { MainLayout as Orders__MainLayout } from "../Orders/MainLayout.js";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { FileUploadComponent } from "@lg/ng-shared";

interface Properties {
    timeStamps: Partial<Record<This.MetadataFile.Id, Date>>;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Orders-MetadataManage',
    templateUrl: './MetadataManage.html',
    styleUrls: ['./MetadataManage.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgSharedModule,
        Orders__MainLayout,
        MatCardModule,
        MatButtonModule,
        FileUploadComponent
    ],
})
export class MetadataManage extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Orders.MetadataManage';
    $isDialog = false;
    $Modules = $Modules;
    Orders = Orders;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {

    };
    var_timeStamps = proxySignal<Partial<Record<This.MetadataFile.Id, Date>>>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get timeStamps() { return component.var_timeStamps() },
                set timeStamps(value: Partial<Record<This.MetadataFile.Id, Date>>) { component.var_timeStamps.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {

        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this
            if (!isVariablesInitialized) this.screen.timeStamps = ({})
            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    _ForBlock_collectionCode_58($scope: any): any[] {
        let { app, screen, $pathSegments, $disabled }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean } = $scope ?? {}

        return (This.MetadataFile.getEntryList() as any[])
    }

    async handler_ButtonBlock_63_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { file, fileIndex, $disabled }: { file: This.MetadataFile.Entry, fileIndex: number, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    const data = await This.MetadataHelper.download(file.id as This.MetadataFile.Id)
                    Sys.App.provideDownload(data, file.path)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_FileUploadBlock_64_filesSelected_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { file, fileIndex, $disabled }: { file: This.MetadataFile.Entry, fileIndex: number, $disabled: any } = $scope ?? {}

        {
            let files: File[] = [...$event]
            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    if (!files.length) return
                    await This.MetadataHelper.upload(file.id as This.MetadataFile.Id, await files[0].arrayBuffer())
                    Sys.App.showNotification('success', 'File updated successfully')
                    await this.action_reloadTimestamps($event)
                    await this.action_reloadPostUpload($event)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            await this.action_reloadTimestamps($event)
        }
    }

    async action_reloadTimestamps($event?: any) {
        const { app, screen, output } = this
        {
            screen.timeStamps = await This.MetadataHelper.getTimestamps()
        }
    }

    async action_reloadPostUpload($event?: any) {
        const { app, screen, output } = this
        {
            await Promise.all([
                This.Vendor.load(true),
                This.VendorMaterial.load(true),
                This.Material.load(true),
            ])
        }
    }
}
